// import { ViewSupport44Component } from "../../../components/SupportSystem/ViewReports/ViewSupport44Component";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarSupportSystem } from "../../../components/share/NavbarSupportSystem";
import { OperationReport44Component } from "../../../components/SupportSystem/OperationReportForm/OperationReport44Component";
export function ViewSupport44Container() {
    const titleName = "แบบรายงานผลการพิจารณาอนุมัติการให้เงินช่วยเหลือหรืออุดหนุนจากกองทุนพัฒนาฝีมือแรงงาน (แบบ ชอ. 4-4)"; //ใส่ชื่อtitle ตรงนี้
    return (
        <div className="page-container bg-landing">
            <NavbarSupportSystem />
            <HeadTitle title={titleName} />
            <OperationReport44Component />
            <Footer />
        </div>
    );
}
